import React from "react";

import { GradientDefs } from "../../GradientDefs";

/**
 * @component GitRepositoryIcon
 * @description
 * Outline repository glyph (a stacked database cylinder) used as a
 * source-control / repository signifier.
 *
 * @prop {string} [gradient] - Optional CSS linear-gradient string applied to the stroke.
 *
 * @see https://design.activecollab.com/docs/foundations/icons
 */
const GitRepositoryIcon = React.forwardRef(
  (
    {
      gradient,
      ...props
    }: React.SVGProps<SVGSVGElement> & {
      gradient?: string;
    },
    ref?: React.Ref<SVGSVGElement>
  ) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={24}
      height={24}
      viewBox="0 0 24 24"
      data-testid="GitRepositoryIcon"
      fill="none"
      stroke={
        gradient
          ? "url(#icon-gradient)"
          : props?.stroke
          ? props.stroke
          : "var(--color-theme-600)"
      }
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
      focusable={false}
      ref={ref}
      {...props}
    >
      <GradientDefs gradient={gradient} />
      <path d="M12 4m-8 0a8 2 0 1 0 16 0a8 2 0 1 0 -16 0" />
      <path d="M4 4v5a8 2 0 0 0 16 0v-5" />
      <path d="M4 9v5a8 2 0 0 0 16 0v-5" />
      <path d="M4 14v5a8 2 0 0 0 16 0v-5" />
    </svg>
  )
);
GitRepositoryIcon.displayName = "GitRepositoryIcon";
export default GitRepositoryIcon;
